import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { UsersTable } from "../shared/Tables/UsersTable";
import { EmptyCheckAll } from "../utils/validation/validation";
import { environment } from "../environment";
import { useKeycloak } from "@react-keycloak/web";
import { useAxios } from "./useAxios";
import { SetRolesIntoOneArrayToMerchant, UserManagementMerhantIdToName, UserManagementNameToMerhantId } from "../utils/userManagment.util";
import { useUserContext } from "../context/user.context";

export const useUserManagement = () => {
  const { t } = useTranslation();
  const { initialized } = useKeycloak();
  const { axiosInstance } = useAxios();
  const { isGlobalUserAdmin, isUserAdmin, merchantId, merchantName, merchantNameAndId } = useUserContext();

  const [loadingFlag, setLoadingFlag] = useState(false);

  const [userExists, setUserExists] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [modalOption, setModalOption] = useState("");
  const [acceptRemoving, setAcceptRemoving] = useState(false);
  const [selectedDeleteRow, setSelectedDeleteRow] = useState();
  const [availableMerchants, setAvailableMerchants] = useState([]);
  const [rolesArray, setRolesArray] = useState([]);
  const [userId, setUserId] = useState("");

  const [usersData, setUsersData] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [formData, setFormData] = useState({});
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedMerchants, setSelectedMerchants] = useState([]);

  //USER TABLE
  const renderUserTable = () => {
    return (
      <UsersTable
        userTableData={tableData}
        onTableDevicesClick={onTableDevicesClick}
        isGlobalUserAdmin={isGlobalUserAdmin}
        merchantName={merchantName}
      />
    );
  };

  //ADD DATA TO THE EDIT FORM
  const onTableDevicesClick = (row) => {
    if (Object.values(row).length) {
      setFormData((oldState) => ({
        ...oldState,
        id: row?.userId,
        keycloakId: row?.keycloakId,
        user: row?.username,
        firstName: row?.firstName,
        lastName: row?.lastName,
        merchantInfo: row?.merchantInfo?.map((val) => ({
          merchant: {
            value: UserManagementMerhantIdToName(val?.merchantId, merchantNameAndId),
            label: `${UserManagementMerhantIdToName(val?.merchantId, merchantNameAndId)}`,
          },
          role: val?.role.map((role) => ({ value: role, label: `${role}` })),
        })),
      }));
    }
  };

  //GET ALL ROLES
  const getAllRoles = () => {
    let url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getUserManagmentRolesMethod}`;

    axiosInstance?.current
      ?.get(url)
      .then((res) => {
        const rolesData = res?.data || [];

        //SET ROLES ARRAY
        setRolesArray(rolesData);

        console.log("USER MANAGEMENT ROLE => ", rolesData);
      })
      .catch((err) => {
        console.log("Nekaj je poslo po zlu :3 => ", err);
      });
  };
  //GET ALL USERS
  const getSuperAdminUsers = () => {
    setLoadingFlag(true);
    let url = "";
    if (isGlobalUserAdmin) {
      url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getSuperAdminUsersMethod}`;
    } else if (isUserAdmin) {
      url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getAdminUsersMethod}?merchantId=${merchantId}`;
    }

    axiosInstance?.current
      ?.get(url)
      .then((res) => {
        const userData = res?.data || [];
        userData.forEach((user) => SetRolesIntoOneArrayToMerchant(user));
        setLoadingFlag(false);
        //SET USER DATA
        setUsersData(userData);
        //SET TABLE DATA
        setTableData(userData);

        if (userId) {
          const row = userData.find((user) => user.userId === userId);
          onTableDevicesClick(row);
        }
        console.log("USER MANAGEMENT USERS => ", userData);
      })
      .catch((err) => {
        setLoadingFlag(false);
        console.log("Nekaj je poslo po zlu :3 => ", err);
      });
  };

  useEffect(() => {
    if (initialized) {
      getAllRoles();
    }
  }, [initialized, merchantId]);
  
  useEffect(() => {
    if (initialized) {
      if (merchantId !== "") {
        getSuperAdminUsers();
      }
    }
  }, [initialized, merchantId]);

  //ADD NEW MERCHANT
  const addAnotherMerchant = (merchants, roles) => {
    setLoadingFlag(true);
    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.postSuperAdminAssignUserMethod}`;

    const roleArray = roles.map((rol) => rol.value);

    axiosInstance?.current
      ?.post(url, {
        merchantId: UserManagementNameToMerhantId(merchants?.value, merchantNameAndId),
        userId: userId,
        userRoles: roleArray,
      })
      .then((res) => {
        setLoadingFlag(false);
        console.log("USER MANAGEMENT POST => ", res);
        getSuperAdminUsers();
      })
      .catch((err) => {
        setLoadingFlag(false);
        console.log("Nekaj je poslo po zlu :3 => ", err);
      });
  };

  //REMOVE MERCHANT FORM USER
  const removeSelectedMerchant = (merchants) => {
    setLoadingFlag(true);
    const merchantIdForDeleting = UserManagementNameToMerhantId(merchants?.merchant?.value, merchantNameAndId);

    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.deleteSuperAdminMerchantMethod}?merchantId=${merchantIdForDeleting}&userId=${userId}`;

    axiosInstance?.current
      ?.delete(url)
      .then((res) => {
        setLoadingFlag(false);
        console.log("USER MANAGEMENT DELETE => ", res);
        getSuperAdminUsers();
      })
      .catch((err) => {
        setLoadingFlag(false);
        console.log("Nekaj je poslo po zlu :3 => ", err);
      });
  };

  //UPDATE USER -> ONLY MERCHANT INFO
  const userUpdate = (user) => {
    setLoadingFlag(true);
    console.log(user);
    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.putSuperAdminEditMethod}`;
    const merchantInfo = user.merchantInfo.map((val) => ({
      merchantId: UserManagementNameToMerhantId(val?.merchant?.value, merchantNameAndId),
      userId: user.id,
      userRoles: val.role.map((rol) => rol.value),
    }));

    console.log("FORM DATA FOR DOUBLE => ", merchantInfo, user);

    axiosInstance?.current
      ?.put(url, merchantInfo)
      .then((res) => {
        setLoadingFlag(false);
        console.log("USER MANAGEMENT PUT => ", res);
        getSuperAdminUsers();
      })
      .catch((err) => {
        setLoadingFlag(false);
        console.log("Nekaj je poslo po zlu :3 => ", err);
      });
  };

  //REMOVE ALREADY USED MERCHANT FROM ARRAY
  const AvailableMerchants = (mock) => {
    if (Object.values(formData).length) {
      formData?.merchantInfo?.map((singleMerchant) => {
        const merchantRegex = new RegExp(`(^|\W)${singleMerchant?.merchant?.value}($|\W)`);
        mock = mock?.filter((val) => !merchantRegex.test(val));
        return mock;
      });
      setAvailableMerchants(mock);
    }
  };

  //FILTERING BY ROLES
  const roleFilter = (role) => {
    const filteredData = usersData.filter((tableData) => {
      const filteredRoles = (selectedRoles || []).map((selected) => selected.value);
      const filteredRole =
        !filteredRoles?.length || filteredRoles.some((r) => tableData?.merchantInfo?.some((merchant) => merchant?.role?.includes(r)));
      //console.log("FILTERED ROLE => ", filteredRole);
      return filteredRole;
    });
    !role.length ? setTableData(usersData) : setTableData(filteredData);
    return filteredData;
  };
  //FILTERING BY MERCHANTS
  const merchantFilter = (role) => {
    const filteredData = usersData.filter((tableData) => {
      const filteredMerchants = (selectedMerchants || []).map((selected) => selected.value);
      const filteredMerchant =
        !filteredMerchants?.length ||
        filteredMerchants.some((r) =>
          tableData?.merchantInfo?.some((merchant) => UserManagementMerhantIdToName(merchant?.merchantId, merchantNameAndId).includes(r))
        );
      return filteredMerchant;
    });
    !role.length ? setTableData(usersData) : setTableData(filteredData);
    return filteredData;
  };

  //SEARCH FROM USERNAME A SPECIFIC USERS
  const searchUsersByUserName = (userName) => {
    const foundUser = usersData.filter((users) => users?.username === userName);
    if (foundUser.length) {
      setUserExists(true);
      foundUser.map((val) => onTableDevicesClick(val));
    } else {
      ShowToastMessage();
      setUserExists(false);
    }
  };

  //TOASTR MESSAGE
  const ShowToastMessage = () =>
    toast(<p className="mx-2 tx-16 d-flex align-items-center mb-0 ">{t("userManagment.userNotFound")}</p>, {
      position: toast.POSITION.TOP_RIGHT,
      hideProgressBar: true,
    });

  useEffect(() => {
    roleFilter(selectedRoles);
  }, [selectedRoles]);
  useEffect(() => {
    merchantFilter(selectedMerchants);
  }, [selectedMerchants]);

  /* useEffect(() => {
    console.log("USER MANAGEMENT state mock event FORM DATA FOR TESTING => ", formData);
  }, [formData]); */

  return {
    formData,
    setFormData,
    selectedRoles,
    setSelectedRoles,
    selectedMerchants,
    setSelectedMerchants,
    addAnotherMerchant,
    removeSelectedMerchant,
    AvailableMerchants,
    searchUsersByUserName,
    userUpdate,
    userExists,
    merchantNameAndId,
    merchantName,
    rolesArray,
    UserTable: renderUserTable(),
    setOpenModal,
    openModal,
    setModalOption,
    modalOption,
    availableMerchants,
    setUserId,
    setAcceptRemoving,
    setSelectedDeleteRow,
    selectedDeleteRow,
    loadingFlag,
  };
};
